export default __webpack_public_path__ + "static/media/Emotion_Happiness .7bd779be.svg";